import React from 'react';
import Styles from './PlanDetailCard.module.scss';
import { HiPencil } from 'react-icons/hi2';
import Form from 'react-bootstrap/Form';
import { LuClock } from 'react-icons/lu';

const PlanDetailCard = ({
  plan,
  selectedPlanType,
  setSelectedPlanType,
  isDisabledSwitch,
  setIsModalOpen,
  isTrial = false,
  isLifetime = false,
}) => {
  // Add defensive check for plan amount
  const planAmount = plan?.amount ? Number(plan.amount) : 0;
  const isValidAmount = !isNaN(planAmount) && planAmount >= 0;

  return (
    <div className={Styles.outerContainer}>
      <div className={Styles.outerContainer__header}>
        <div className="d-flex align-items-center gap-3">
          <span className={Styles.outerContainer__header__heading}>
            Plan Details
          </span>
          {isTrial && (
            <div className={Styles.trail_days}>
              <LuClock color="#00a7b7" size={'16px'} />
              <span>3 days free trial</span>
            </div>
          )}
        </div>
        {!isLifetime && (
          <button
            className={Styles.outerContainer__header__btn}
            onClick={() => setIsModalOpen(true)}
          >
            <HiPencil size={16} />
            <span>Change Plan</span>
          </button>
        )}
      </div>
      <div className={Styles.outerContainer__card}>
        <div className={Styles.outerContainer__card__left}>
          <div className={Styles.outerContainer__card__left__top}>
            <span className={Styles.outerContainer__card__left__top__heading}>
              {plan?.type || 'No Plan Selected'}
            </span>
            <span className={Styles.outerContainer__card__left__top__detail}>
              {isLifetime
                ? '(Lifetime)'
                : `(${selectedPlanType === 'month' ? 'Monthly' : 'Annually'})`}
            </span>
          </div>
          <div className={Styles.outerContainer__card__left__bottom}>
            <span
              className={Styles.outerContainer__card__left__bottom__heading}
            >
              ${isValidAmount ? planAmount : 0}
            </span>
            <span className={Styles.outerContainer__card__left__bottom__detail}>
              {isLifetime ? ' one-time' : `/${selectedPlanType}`}
            </span>
          </div>
        </div>
        {!isLifetime && (
          <div className={Styles.outerContainer__card__right}>
            <div
              className={`${Styles.outerContainer__card__right__toggleContainer} ${selectedPlanType === 'year' ? Styles.yearly : ''}`}
            >
              <span
                className={selectedPlanType === 'month' ? Styles.active : ''}
                onClick={() => {
                  if (!isDisabledSwitch) {
                    setSelectedPlanType('month');
                  }
                }}
              >
                Monthly
              </span>
              <Form>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label=""
                  className={Styles.outerContainer__card__right__switch}
                  onChange={() => {
                    if (!isDisabledSwitch) {
                      setSelectedPlanType(
                        selectedPlanType === 'year' ? 'month' : 'year',
                      );
                    }
                  }}
                  checked={selectedPlanType === 'year'}
                  disabled={isDisabledSwitch}
                />
              </Form>
              <span
                className={selectedPlanType === 'year' ? Styles.active : ''}
                onClick={() => {
                  if (!isDisabledSwitch) {
                    setSelectedPlanType('year');
                  }
                }}
              >
                Yearly
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlanDetailCard;
